import { useAppName, useLanguage, useSitecoreApiHost, useSitecoreApiKey } from '../../utils/sitecoreContext';
import { useGetRecommendedVehiclesQuery } from '../apis/layoutServiceApi';
const DMM_API_RECOMMENDED_VEHICLES_PATH = 'dmmapi/inventory/recommendedvehicles';
const isSelectionValid = (selections) => !!(selections.modelKey && selections.modelYear && selections.dealerCode);
const useFetchLayoutServiceRecommendedVehicles = (selections, carsSedansPrecedence, suvsTrucksPrecedence, shouldFetch) => {
    const appName = useAppName();
    const language = useLanguage();
    const sitecoreApiHost = useSitecoreApiHost();
    const sitecoreApiKey = useSitecoreApiKey();
    return useGetRecommendedVehiclesQuery({
        url: `${sitecoreApiHost}/${DMM_API_RECOMMENDED_VEHICLES_PATH}?sc_apikey=${sitecoreApiKey}&sc_site=${appName}&sc_lang=${language}`,
        body: {
            selections,
            carsSedansPrecedence,
            suvsTrucksPrecedence,
        },
    }, { skip: !shouldFetch || !isSelectionValid(selections) });
};
export default useFetchLayoutServiceRecommendedVehicles;
